import React from "react";

export default function ColorPicker({
  selectedColor,
  handleColorChange,
  disabled = false,
}: {
  selectedColor?: string;
  handleColorChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}) {
  return (
    <div className="h-16 w-16 border-2 border-dashed">
      <input
        type="color"
        value={selectedColor}
        onChange={handleColorChange}
        className="w-full h-full disabled:cursor-not-allowed"
        disabled={disabled}
      />
    </div>
  );
}
